import { getLocalStorageTenantId } from "./localStorage";
import InternalTenantGuard from "./TenantGuard";

/**
 * Retrieve the current tenant id. This can be used by other components to retrieve the tenant id.
 */
export function getTenantId(): string | null {
  return getLocalStorageTenantId();
}

export { InternalTenantGuard as TenantGuard };
